__turbopack_context__.v({
  "isModal": "ResetPasswordAlert-module-scss-module__eosQoW__isModal",
  "resetPasswordAlert": "ResetPasswordAlert-module-scss-module__eosQoW__resetPasswordAlert",
  "resetPasswordAlertSubText": "ResetPasswordAlert-module-scss-module__eosQoW__resetPasswordAlertSubText",
});
